import { MatButtonModule } from '@angular/material/button'
import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { Router } from '@angular/router'

@Component({
	standalone: true,
	imports: [CommonModule, MatIconModule, MatButtonModule],
	selector: 'feature-porto-bank-login-or-signup',
	template: `
		<section
			style="padding: 16px; display: flex; flex-direction: column; align-items: flex-start; gap: 16px;"
		>
			<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
				<mat-icon svgIcon="porto-bank-icons:alert"></mat-icon>

				<mat-icon
					svgIcon="porto-bank-icons:close-circle"
					(click)="dialogRef.close()"
					style="cursor: pointer;"
				></mat-icon>
			</div>

			<h1 style="font-size: 22px; font-weight: 600; color: #000;">Cadastre-se ou faça login</h1>

			<p style=" padding-right: 20px; color: var(--content-txt-black);">
				Comece a usufruir dos benefícios exclusivos do seu cartão PortoBank realizando seu cadastro ou
				login.
			</p>

			<div style="display: flex; gap: 8px; align-self: flex-end; margin-top: 16px;">
				<button
					mat-button
					(click)="login()"
					style="background-color: #fff; color: var(--content-primary); font-weight: 600; font-size: 15px; max-width: 80px; height: 30px; border: 1px solid var(--content-primary);"
				>
					login
				</button>
				<button
					mat-button
					(click)="signup()"
					style="background-color: var(--content-primary); color: white; font-weight: 600; font-size: 15px; max-width: 80px; height: 30px"
				>
					Cadastro
				</button>
			</div>
		</section>
	`,
})
export class LoginOrSignupComponent {
	private router = inject(Router)
	public dialogRef = inject(MatDialogRef<LoginOrSignupComponent>)

	login() {
		this.router.navigate(['entrar'], { queryParams: { login: true } })
		this.dialogRef.close()
	}

	signup() {
		this.router.navigate(['entrar'])
		this.dialogRef.close()
	}
}
